import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { TaasVwgV2Data } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { isGebaeudeYoungerThanFiveYears } from '../../app/shared/selectors/gebaeude.selector';
import { VwgActions } from '../vwgActions';
import { buildTaasVWGDataForStrecke } from './transformer/vwgData.transformer';

const requestActions = [
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
  VwgActions.PREISE_REQUESTED,
  VwgActions.GEFAHREN_CHECKED,
  VwgActions.SELBSTBETEILIGUNG_CHANGED,
  VwgActions.MAP_COORDINATES_VWG_CHANGED_ANGEBOT,
  VwgActions.EXTREMEWETTERSCHUTZ_SELBSTBETEILIGUNG_CHANGED,
  VwgActions.HAUS_TECHNIK_SCHUTZ_LEISTUNG_CHANGED,
  VwgActions.VERSICHERTE_NEBENGEBAEUDE_LEISTUNG_CHANGED,
  VwgActions.AUSSENPOOL_IN_HTS_CHANGED,
];
const successActions = [
  StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VWG_V2,
  StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VWG_V2,
];

export const streckenTarifierer = new StreckenTarifierer(
  {
    appId: App.VWG_V2,
    successEventWithInfo: StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VWG_V2,
    successEventWithoutInfo:
      StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VWG_V2,
    errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_VWG_V2,
  },
  buildTaasVWGDataForStrecke,
  null,
  createHashedRelevantRiskdataVWG,
);

export function* streckenTarifierungVWG(): Generator<ForkEffect> {
  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.VWG_V2));
  yield takeEvery(successActions, safeSaga(streckenTarifierer.handleSuccess, App.VWG_V2));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_VWG_V2,
    safeSaga(streckenTarifierer.handleError, App.VWG_V2),
  );
}

export function createHashedRelevantRiskdataVWG(taasData: TaasVwgV2Data): string {
  const relevantData = { ...taasData };
  delete relevantData.gisDaten;
  delete relevantData.salesProducts;
  delete relevantData.spartenType;
  if (isGebaeudeYoungerThanFiveYears(relevantData.gebaeude.baujahr)) {
    delete relevantData.vorversicherung;
  }
  return createHashedTaasData(relevantData);
}
